const React = require('react');

const AppDataContext = React.createContext({});

const Common = class Common extends React.Component {

};

Common.contextType = AppDataContext;

module.exports = Common;
